<template>
    <div>
        <apexchart ref="graphical_chart" type="radialBar" height="230" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    name: 'GraphicalChart',
    components: { apexchart: VueApexCharts },

    props: ['graphical'],

    data(){
        return{
            series: [],
            chartOptions: {
                colors: [this.graphical.color],
                chart: {
                    height: 230,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 15,
                            size: '65%',
                            image: this.graphical.image,
                            imageWidth: 65,
                            imageHeight: 65,
                            imageClipped: false
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                show: false,
                            },
                            value: {
                                show: true,
                                color: '#000',
                                offsetY: 100,
                                fontSize: '12px',
                                fontFamily: 'Verdana',
                            }
                        }
                    }
                },
            },

        }
    },

    methods: {
        updateSeries() {
            this.series = [this.graphical.data];
        },
    },

    mounted() {
        this.updateSeries();
    },

    watch: {
        graphical: function(){
            this.updateSeries();
        }
    }
}
</script>

<style>

</style>